var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.changePassword_title } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-5 mx-0" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold" },
            [
              _c(
                "b-col",
                { attrs: { sm: "5" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.idtfr"),
                      inputValue: _vm.login,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.connectToGoogle
                ? _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.orig_pwd"),
                          inputType: "password",
                        },
                        model: {
                          value: _vm.originalPassword,
                          callback: function ($$v) {
                            _vm.originalPassword = $$v
                          },
                          expression: "originalPassword",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold" },
            [
              _vm.connectToGoogle
                ? _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.pwd"),
                          inputType: "password",
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function ($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.connectToGoogle
                ? _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.new_pwd"),
                          inputType: "password",
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function ($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "5" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.conf_pwd"),
                      inputType: "password",
                    },
                    model: {
                      value: _vm.confirmNewPassword,
                      callback: function ($$v) {
                        _vm.confirmNewPassword = $$v
                      },
                      expression: "confirmNewPassword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.connectToGoogle
            ? _c("b-row", [
                _c(
                  "div",
                  { staticClass: "text-right col-sm-12 small font-italic" },
                  [_vm._v(_vm._s(_vm.$t("profilesPage.ggl_check_pwd")))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "form-group justify-content-end mr-5" },
            [
              _c(
                "b-col",
                { attrs: { lg: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        title: _vm.changePassword_Validatechanges,
                        variant: "primary",
                      },
                      on: { click: _vm.changePassword },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-floppy-disk" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }